/** Prefixo Vite (ex. /play/retro/) — fiável mesmo sem barra final no URL. */
export function getAppBase() {
  const base = import.meta.env.BASE_URL || '/';
  return base.endsWith('/') ? base : `${base}/`;
}

export function appUrl(path) {
  const rel = getAppBase() + String(path || '').replace(/^\//, '');
  if (typeof window === 'undefined') return rel;
  if (rel.startsWith('http://') || rel.startsWith('https://')) return rel;
  return `${window.location.origin}${rel.startsWith('/') ? '' : '/'}${rel}`;
}
